import React from "react";
import MainLayout from "../../layout/MainLayout";
import CancerMainHeader from "../../layout/Header/CancerMainHeader";
import CancerTwoBuFooter from "../../layout/Footer/CancerTwoBuFooter";
import FormList from "./FormList";
const ProstateFormResult = ({
  onPageChange,
  onLinkHome,
  score,
  data,
  onChange,
  onTotal,
}) => {
  // 다음으로 페이지 이동
  const handlePageMove = () => {
    onTotal();
  };

  return (
    <MainLayout
      header={<CancerMainHeader cancer="전립선암" sub={true} />}
      footer={
        <CancerTwoBuFooter
          name1="뒤로"
          name2="위험도 계산"
          onClick1={() => onPageChange(1)}
          onClick2={() => handlePageMove()}
        />
      }
    >
      <FormList
        score={score}
        onPageChange={onPageChange}
        onLinkHome={onLinkHome}
        data={data}
        onChange={onChange}
        onTotal={onTotal}
      />
    </MainLayout>
  );
};

export default ProstateFormResult;
